// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3mt5r","productName":"Table_productName__2D0-c"};